import React from "react"

import { ActionAnchor, ActionType } from "@tenforce/toolbox-button-push-react"
import { Symbols } from "@tenforce/toolbox-fontmap"

import { IClickableCard } from "../../../models/starterpack"

export interface Props extends IClickableCard {
    element: string
}

export const ClickableCard = ({
    id,
    title,
    url,
    label,
    element,
}: Props): JSX.Element => (
    <div
        key={id}
        className="theme-thumb bg-cloud theme-thumb--normalAlignment has-hidden-actions tw-mx-0 tw-my-1"
        data-ft-component={element}
        data-ft-id={id}
        data-ft-title={title}
    >
        <div className="tw-flex-1 tw-flex tw-flex-col">
            <div data-ft-component="label" className="label is-dimmed">
                {label}
            </div>
            <div data-ft-component="title">{title}</div>
        </div>

        <aside className="tw-content-center">
            <ActionAnchor
                actionType={ActionType.icon}
                extraClasses="is-hidden-action"
                data-ft-component="goToLink"
                href={url}
                title={title}
            >
                {Symbols.ArrowForward}
            </ActionAnchor>
        </aside>
    </div>
)

export default ClickableCard
